import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, DatePicker, TimePicker, Select, Cascader, InputNumber } from 'antd';
import { Row, Col, Slider } from 'antd';
import { message } from 'antd';
// import { text_mk } from './formCtlMK/SgiTextMaker';
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory'
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { getJsonLength, copy } from 'rt-sd-common/sgiCommon/sgiCommon';
import style from './SgiPanel.css';
import { AllCompGUID } from 'rt-sd-common/sgiConstants/SgiCompConstant';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
const FormItem = Form.Item;

class SgiForm extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            formProps: { style: { height: '100%', width: '100%' }, className: "sgiForm" },//form属性
            formItems: [], //form下控件数组
            panelTitleProps: { style: {} },//panel的title属性
            formBodyProps: { style: { flex: 1 } },//form的body属性
            toolbarTopItems: [],
            toolbarBottomItems: [],
            loading: false,
            isLabel: false,
            cstmFullItemFlg: false,//默认非完全自定义items
            cstmItemFlg: false,//默认非行列自定义items
        };

        // let { parentModule, moduleDesc, objFct, type } = this.props;
        // //组装属性
        // this.form_mk(parentModule, moduleDesc, objFct, type);
    }

    /**
     * 获取Form下的所有控件的Values
     */
    getFieldsValue() {

    }

    /**重置所有组件 */
    resetFields() {

    }

    /**获取form下所有控件 */
    getFields() {
        let resultFields = {};
        this.getLeafFields(this.refs, resultFields);
        return resultFields;
    }

    //遍历寻找下级refs，最底层的是form组件，前面都是布局用的
    getLeafFields(fields, resultFields) {
        let item;
        for (let itemKey in fields) {
            item = fields[itemKey];
            if (getJsonLength(item.refs) > 0) { //第一层
                this.getLeafFields(item.refs, resultFields);
            } else {
                resultFields[itemKey] = item;
            }
        }
    }

    /**
     * 设置一组输入控件的值
     * @param { fieldName: value } FieldsValue
     */
    setFieldsValue(FieldsValue) {
        let fields = this.getFields();
        //循环所有子控件，调用他们的刷新方法
        let item;
        for (var index in fields) {
            item = fields[index];
            let attname = item.state.attname;
            if (!attname || !item.setValue) {
                continue;
            }

            // 级联组件等多属性组件属性值合并
            let atts = [], vals = [];
            if (attname.indexOf(",") !== -1) {
                atts = attname.split(",");
                atts.forEach(att => {
                    vals.push(FieldsValue[att]);
                });
                item.setValue(vals);
            }
            // 其他正常组件
            else {
                let value = FieldsValue[attname];
                item.setValue(value);
            }
        }
    }

    /**
     * 从对象工厂中取值 刷新
     */
    refreshValues() {
        let { objFct, moduleDesc } = this.props;
        let bdInst = getConstByKey(this, moduleDesc.bdInst);
        if (bdInst && objFct) {
            let value = objFct.get(bdInst);
            this.setFieldsValue(value);
        }
    }

    /**
     * 校验并获取一组输入域的值与 Error
     * @param {*} Fields
     */
    validateFields() {
        let errors = this.getFieldsError();
        if (errors && errors.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    /**获取一组输入控件的 Error  */
    getFieldsError() {
        let fields = this.getFields();
        let errors = [];
        let errorMsg;
        //循环所有子控件，调用他们的刷新方法
        let item;
        for (var index in fields) {
            item = fields[index];
            if (!item.validate) {
                continue;
            }
            errorMsg = item.validate();
            if (errorMsg) {
                errors.push(errors);
            }
        }
        return errors;
    }


    /**
     * 根据描述创建form
     * @param {父组件} parentModule
     * @param {描述} moduleDesc
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    form_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.formItems = []; //再次渲染的时候清空

        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.formProps, this.state.formBodyProps);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.formProps, this.state.panelTitleProps);
        //组装form表单下的控件信息
        if (type !== "dnd") this.fitFormItems(moduleDesc, this.state.formItems, this.state.toolbarTopItems, this.state.toolbarBottomItems);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.formProps);
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} formProps
     */
    bindEvent(moduleDesc, formProps) {

    }

    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    fitFormItems = function (moduleDesc, formItems, toolbarItems, toolbarBottomItems) {
        var me = this;

        let { objFct, type } = this.props;
        let bdInst = getConstByKey(this, moduleDesc.bdInst);
        if (bdInst && objFct && !objFct.get(bdInst)) {
            objFct.set(bdInst, {});
        }

        //查看是否绑定了DV，如果绑定了DV，获取DV信息，DV下的数据绑定到当前form下
        var bdDvId = moduleDesc.bdDvId;
        if (bdDvId) {
            //暂时先不处理
            var dvs = bdDvId.split(",");
            dvs.forEach((item, index) => {
                var dvJson = PrmFactory.getPrm(item);
                this.setDVItems(dvJson, formItems, bdInst);
            })
        }


        //老开发系统遗留，老系统form作为布局控件，现在临时实现垂直布局，和水平布局
        //这个方法临时，以后重新开发的新系统可能不用
        this.adaptLayout(moduleDesc);

        //form下的子节点添加到form组件中
        let cldSet = moduleDesc.cldSet;
        if (cldSet && cldSet.length && cldSet.length > 0) {
            this.setFormCtlItems(cldSet, formItems, toolbarItems, toolbarBottomItems, bdInst);
        }
    }


    /**
     * 适应老系统垂直布局和水平布局
     * @param {*} moduleDesc
     */
    adaptLayout(moduleDesc) {
        let cldSet = moduleDesc.cldSet;
        let layout = moduleDesc.t;
        let sumflx = 0;

        if (!cldSet) {
            return;
        }

        cldSet.forEach((item, index) => {
            sumflx = sumflx + item.flx;
        })

        if (layout == 'hbox') {
            cldSet.forEach((item, index) => {
                item.row = 1;
                if (sumflx && item.flx) {
                    item.span = parseInt(item.flx / sumflx * 24);
                }
            })
        } else if (layout == 'vbox') {
            cldSet.forEach((item, index) => {
                item.row = index + 1;
                if (sumflx && item.flx) {
                    item.span = 24;
                }
            })
        }
    }

    /**
     *
     * @param {*} bdDvId
     * @param {*} formItems
     */
    setDVItems(dvJson, formItems, bdInst) {
        let { objFct, type } = this.props;
        if (!dvJson) {
            return;
        }
        if (!dvJson.cldSet) {
            return;
        }
        //获取子空间的布局row信息
        let rowInfo = this.setFormCtlRowInfo(dvJson.cldSet);
        // tool.sgiLogger.log(111111111111111111)

        //拼装控件
        let rowItemList, colList, span, offset;
        for (var rowkey in rowInfo) {
            rowItemList = rowInfo[rowkey];
            colList = [];
            rowItemList.forEach((item, index) => {
                span = item.span;
                offset = item.offset;
                if (!span) span = 12;
                if (!offset) offset = 0;
                colList.push(<Col span={span} offset={offset}>
                    {convertModuleByGuid(this, item.cldSet[0], bdInst, objFct, type)}</Col>)
            });
            formItems.push(<Row>{colList}</Row>);
        }
    }



    /**
     * 添加子控件
     */
    setFormCtlItems = function (sonitems, formItems, toolbarItems, toolbarBottomItems, bdInst) {
        let { objFct, type } = this.props;

        //获取子空间的布局row信息
        let rowInfo = this.setFormCtlRowInfo(sonitems);

        //拼装控件
        let rowItemList, colList, span, offset;
        for (var rowkey in rowInfo) {
            rowItemList = rowInfo[rowkey];
            colList = [];
            rowItemList.forEach((item, index) => {
                span = item.span;
                offset = item.offset;
                if (!span) span = 24;
                if (!offset) offset = 0;
                //如果是工具条的话，放入到工具条中make，不跟其他控件一起make
                if (item.desId === AllCompGUID.TOOLBAR) {
                    if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
                        toolbarItems.push(convertModuleByGuid(this, item, bdInst, objFct, type));
                    } else {
                        toolbarBottomItems.push(convertModuleByGuid(this, item, bdInst, objFct, type));
                    }
                } else {
                    let copyItem = copy(item, true);//单向，不能修改原描述
                    if (this.state.isLabel) this.setAllItemIsLabel(copyItem, true);
                    // else this.setAllItemIsLabel(copyItem, false);//这里不能添加，作为当form可填写时，组件使用自定义的方式：可填写/仅展示
                    this.setFormProps(copyItem, this.state.formProps);
                    colList.push(<Col style={{}} span={span} offset={offset}>
                        {convertModuleByGuid(this, copyItem, bdInst, objFct, type)}</Col>)
                }
            });
            formItems.push(<Row style={{}}>{colList}</Row>);
        }
    }

    setAllItemIsLabel(item, isLabel) {
        if (!item) return;
        item.isLabel = !!isLabel;
        if (item.cldSet) {
            item.cldSet.forEach(cld => {
                this.setAllItemIsLabel(cld, isLabel);
            });
        }
    }

    /**
     * 递归为子组件添加_formProps属性，将form属性传递下去
     * @param {object} item 子组件描述
     * @param {object} formProps form属性对象
     */
    setFormProps(item, formProps) {
        if (!item || !formProps) return;
        item._formProps = formProps;
        if (item.cldSet) {
            item.cldSet.forEach(cld => {
                this.setFormProps(cld, formProps);
            });
        }
    }

    /**
     * 设置是否仅显示标识(外部方法接口)
     * @author hanzb
     * @param {boolean} isLabel 是否仅显示
     */
    setIsLabel(isLabel) {
        // 重置部分状态
        this.state.isLabel = !!isLabel;
        this.setFormIsLabel(this.refs, !!isLabel);
        // 刷新
        this.setState({});
    }

    setFormIsLabel(refs, isLabel) {
        for (const key in refs) {
            let ref = refs[key];
            if (ref) {
                ref.setState({ formIsLabel: isLabel });
                if (ref.refs) {
                    this.setFormIsLabel(ref.refs, isLabel);
                }
            }
        }
    }

    /**
     * 设置整个表单是否禁用(外部接口)
     * @param {boolean} disabled 是否禁用
     */
    setDisabled(disabled) {
        this.setFormDisabled(this.refs, disabled);
    }

    setFormDisabled(refs, disabled) {
        for (const key in refs) {
            const ctl = refs[key];
            if (!ctl) continue;
            if (ctl.setFormDisabled) ctl.setFormDisabled(disabled);
            if (ctl.refs) this.setFormDisabled(ctl.refs, disabled);
        }
    }

    /**
     * 设置布局
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    setFormCtlRowInfo = function (sonitems) {
        let nullrowList = [];
        let rowInfo = {};
        let colList = [];
        let row, span, offset, currentSonItem;
        for (var i = 0; i < sonitems.length; i++) {
            currentSonItem = sonitems[i];
            row = currentSonItem.row;
            span = currentSonItem.span;
            if (row) {
                if (!rowInfo[row]) {
                    rowInfo[row] = [];
                }
                rowInfo[row].push(currentSonItem);
            } else {
                nullrowList.push(currentSonItem)
            }
        }
        if (nullrowList.length > 0) {
            rowInfo.nullrow = nullrowList;
        }
        return rowInfo;
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded || this.props.type == 'dnd') {
            //组装属性
            this.form_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.formProps);

        let showToolbarTopItems = [...this.state.toolbarTopItems];
        let showToolbarBottomItems = [...this.state.toolbarBottomItems];
        let showFormItems = [...this.state.formItems];
        const { cstmFullItemFlg, cstmFullItem, cstmItemFlg, cstmItem } = this.state;
        // 完全自定义子组件处理
        if (cstmFullItemFlg && typeof cstmFullItem === "function" && type !== "dnd") {
            let cldSet = cstmFullItem(this, objFct);
            if (cldSet) this.setFormCtlItems(cldSet, showFormItems, showToolbarTopItems, showToolbarBottomItems, getConstByKey(this, moduleDesc.bdInst));
        }
        // 行列布局自定义子组件处理
        if (cstmItemFlg && typeof cstmItem === "function" && type !== "dnd") {
            let cstmDesc = cstmItem(this, objFct);
            if (cstmDesc) {
                let col = cstmDesc.col || 3;
                let cldSet = cstmDesc.cldSet || [];
                let width = (100 / col) + "%";
                let newCldSet = [{ "ctlN": "行", "desId": "EP_EO_UI_5101" }];
                let rowCldSet = newCldSet[0].cldSet = [];
                cldSet.forEach(cld => {
                    rowCldSet.push({ "ctlN": "列", "desId": "EP_EO_UI_5102", "style": { width }, cldSet: [cld] });
                });
                this.setFormCtlItems(newCldSet, showFormItems, showToolbarTopItems, showToolbarBottomItems, getConstByKey(this, moduleDesc.bdInst));
            }
        }

        return (
            <Form {...this.state.formProps}>
                <div style={{ height: '100%', width: '100%', display: 'flex', 'flex-direction': 'column' }}>
                    {showToolbarTopItems ? showToolbarTopItems : null}
                    <div className={style.title} {...this.state.panelTitleProps}>
                        <span>{this.state.panelTitleProps.title}</span>
                    </div>
                    <div {...this.state.formBodyProps}>
                        {showFormItems}
                        {this.props.children}
                    </div>
                    {showToolbarBottomItems ? showToolbarBottomItems : null}
                </div>
            </Form>
        )
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    AddAttribute = function (moduleDesc, formProps, panelTitleProps) {
        // 整个form是否只作为显示组件
        const isLabel = moduleDesc.isLabel;
        this.state.isLabel = !!isLabel;

        var text = formProps.te;//公共方法里已从资源获取了//Resource.getTRByPrm(moduleDesc).te; //form标题
        if (text) panelTitleProps.title = text;

        var lblAlgn = moduleDesc.lblAlgn; //标签对齐方式
        if (lblAlgn) formProps.labelAlign = lblAlgn;

        var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
        if (ttlAlgn) panelTitleProps.style['text-align'] = ttlAlgn;

        var isTtl = moduleDesc.isTtl; //form是否显示标题
        if (!isTtl) {
            panelTitleProps.style.display = "none";
        } else {
            panelTitleProps.style.display = undefined;
        }

        // 冒号
        formProps.colon = !!moduleDesc.colon;

        // 是否换行
        let nowrap = moduleDesc.nowrap;
        if (nowrap) {
            this.state.formProps.className += " sgiForm-nowrap";
        }

        // 标签宽度自适应
        let lblAuto = moduleDesc.lblAuto;
        if (lblAuto) {
            this.state.formProps.className += " sgiForm-lblAuto";
        }

        // 完全自定义formItems
        const cstmFullItem = moduleDesc.cstmFullItem;
        if (cstmFullItem) {
            let $cstmFullItem;
            try {
                $cstmFullItem = new Function("module", "objFct", cstmFullItem);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            if ($cstmFullItem) {
                this.state.cstmFullItem = $cstmFullItem;
            }
            this.state.cstmFullItemFlg = true;
        }

        // 行列自定义formItems
        const cstmItem = moduleDesc.cstmItem;
        if (cstmItem) {
            let $cstmItem;
            try {
                $cstmItem = new Function("module", "objFct", cstmItem);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            if ($cstmItem) {
                this.state.cstmItem = $cstmItem;
            }
            this.state.cstmItemFlg = true;
        }

        var icon = moduleDesc.icon; //form背景图片??没实现
        var bdsty = moduleDesc.bdsty; //form背景颜色??没实现
        var isCls = moduleDesc.isCls; //form是否可以关闭??没实现
        var isFrm = moduleDesc.isFrm; //form是否填充??没实现-----del
        // var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
        var html = moduleDesc.html; //form显示html元素??没实现
        var isDis = moduleDesc.isDis; //form是否禁用??没实现
        var csstyle = moduleDesc.csstyle; //form样式??没实现
        var flx = moduleDesc.flx; //form占比??没实
    }
}
//给类添加公共方法
Object.assign(SgiForm.prototype, sgiCtnBaseFun);
export { SgiForm };
export default SgiForm;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiForm.js